<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-7 col-12 title-trends">Riesgos globales y nacionales</div>
        <div class="col-sm-5 col-12">
            <div class="row justify-content-end">
                <a class="col-3" routerLink="../riesgo-global">
                    <img class="icon-trends" src="assets/img/t/tg-b.webp" alt="Riesgo global"> </a>
                <a class="col-3" routerLink="../riesgo-territorial">
                    <img class="icon-trends" src="assets/img/t/tt-w.webp" alt="Riesgo territorial"> </a>
            </div>
        </div>
    </div>
    <br>

    <div class="principal-summary">Condiciones o eventos <b>potenciales</b> que, de ocurrir, tendrían un
        impacto negativo sobre el bienestar de la <b>población peruana o el desarrollo nacional</b>. Estos eventos
        futuros pueden priorizarse según su probabilidad de ocurrencia y magnitud de impacto. En ese sentido, se
        presenta a continuación los resultados de este análisis, así como la información de cada uno de los riesgos, la
        cual puede ser revisada seleccionando el evento de interés según temática
    </div>
    <app-carousel [idEventTypeForSlider]="idTier1"></app-carousel>
    <div class="normal-text mt-4"> Seleccione el periodo para explorar los principales riesgos globales:
    </div>
    <br>
    <div class="row">
        <div class="col-4 col-sm-3" *ngFor="let d of scatterperiod" style="margin-bottom: 10px;">
            <div class="card-elements" (click)="onDateSelected(d)" [ngClass]="{'active-risk': selectedItem == d.id}">
                <div class="box-text-btn text-center">{{d.period}} - {{+d.period + 10}}</div>
            </div>
        </div>
    </div>
    <br>
    <div class="container body-ut">
        <div class="svg-ut">
            <p class="text-justify" *ngIf="selectedPeriod">
                <span [innerHTML]="selectedPeriod.description"></span>
            </p>
            <!-- botón para descargar reporte-->
            <div class="container-button">
                <div class="row" style="display: flex; flex-direction: spa; justify-content: space-between;">
                    <div class="col-sm-12">
                        <a class="btn-foi" *ngIf="selectedPeriod" [href]="selectedPeriod.url" target="_blank">
                            <i class="fa fa-file-pdf-o icon-pdf"></i>Descargar el reporte {{selectedPeriod.period}} -
                            {{+selectedPeriod.period +10}}
                        </a>
                    </div>
                </div>
            </div>
            <br>
            <!-- fin de botón -->
            <h5 class="div-info"> Seleccione un nodo ( <i class="fa fa-stop fa-rotate-45 fa-icon"></i> ) para
                interactuar
                con el mapa de riesgos.</h5>
            <br>

            <div class="col-sm-12 col-md-12">
                <ng-container *ngIf="scatterpoint && scatterpoint.length > 0">
                    <app-scatter [t3]="t3" [band]="band" [scatterpoint]="scatterpoint" [dx1]="dx1" [dx2]="dx2"
                        [dy1]="dy1" [dy2]="dy2"></app-scatter>
                </ng-container>
            </div>
        </div>
    </div>
    <br>

    <div class="row">
        <div class="container-legend">
            <p class="legend">Leyenda:
                <span class="element-legend"><i class="fa fa-square fa-rotate-45" aria-hidden="true"
                        style="color: rgb(255, 85, 51)"></i> Sociedad</span>
                <span class="element-legend"><i class="fa fa-square fa-rotate-45" aria-hidden="true"
                        style="color:  rgb(5, 145, 65)"></i> Ambiente</span>
                <span class="element-legend"><i class="fa fa-square fa-rotate-45" aria-hidden="true"
                        style="color:  rgb(78, 135, 198)"></i> Tecnología</span>
                <span class="element-legend"><i class="fa fa-square fa-rotate-45" aria-hidden="true"
                        style="color: rgb(239, 197, 20)"></i> Economía</span>
                <span class="element-legend"><i class="fa fa-square fa-rotate-45" aria-hidden="true"
                        style="color: rgb(154, 32, 226)"></i> Político</span>
            </p>
        </div>
    </div>

</div>